<template>
	<div>
        <mobile-search-form v-model="searchUsuario" placeholder="Buscar Usuarios"></mobile-search-form>
		<page-title-bar :class-container="$vuetify.breakpoint.smAndDown ? '' : 'pa-0'">
			<template slot="actions">
                <v-text-field clearable flat solo prepend-icon="search" v-model="searchUsuario" placeholder="Buscar Usuarios" class="search-bar"></v-text-field>
                <div class="mobile-search d-none">
                    <v-tooltip top>
                        <v-btn slot="activator" icon large class="mobile-search-btn" @click="toggleSearchForm">
                            <v-icon color="grey">search</v-icon>
                        </v-btn>
                        <span>Buscar Usuarios</span>
                    </v-tooltip>
                </div>
				<v-tooltip top>
					<v-btn slot="activator" icon large @click="getData">
						<v-icon color="grey">ti ti-reload</v-icon>
					</v-btn>
					<span>Recargar Usuarios</span>
				</v-tooltip>
				<v-tooltip top v-if="permisos.add">
					<v-btn slot="activator" icon large @click="registerUser(null)">
						<v-icon color="grey">ti ti-plus</v-icon>
					</v-btn>
					<span>Crear Usuario</span>
				</v-tooltip>
			</template>
		</page-title-bar>
		<v-container fluid grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pa-2'">
			<v-layout row wrap v-if="users !== null">
                <app-card
                        :fullBlock="true"
                        colClasses="xs12 sm6 md4 col-height-auto"
                        class="top-author-wrap"
                        v-for="(user, index) in users"
                        :key="index"
                >
                    <div class="primary pos-relative white--text">
                        <div class="text-xs-right">
                            <v-tooltip top>
                                <v-btn slot="activator" icon small>
                                    <v-icon color="white" small>ti ti-key</v-icon>
                                </v-btn>
                                <span>Restablecer contraseña</span>
                            </v-tooltip>
                            <v-tooltip top v-if="permisos.edit">
                                <v-btn slot="activator" icon small @click.stop="registerUser(user.id)">
                                    <v-icon color="white" small>ti ti-pencil</v-icon>
                                </v-btn>
                                <span>Editar</span>
                            </v-tooltip>
                        </div>
                        <h5 class="mb-0 text-center">{{user.name}}</h5>
                    </div>
                    <div class="author-detail-wrap">
                        <div class="author-avatar primary pos-relative mb-4 text-xs-center">
                            <div class="avatar-img">
                                <img src="/static/avatars/avatarMangaM.jpg" width="87" height="87" class="img-responsive mx-auto rounded-circle">
                            </div>
                        </div>
                        <div class="px-3 authors-info">
                            <ul class="list-unstyled author-contact-info mb-2">
                                <li>
                                    <span class="mr-3"><i class="zmdi zmdi-account"></i></span>
                                    <a class="fs-12 grey--text fw-normal">{{user.username}}</a>
                                </li>
                                <li>
                                    <span class="mr-3"><i class="zmdi zmdi-email"></i></span>
                                    <a class="fs-12 grey--text fw-normal">{{user.email}}</a>
                                </li>
                                <li>
                                    <span class="mr-3"><i class="zmdi zmdi-accounts-alt"></i></span>
                                    <a class="fs-12 grey--text fw-normal">Rol</a>
                                    <ul>
                                        <li class="fs-12 grey--text fw-normal" v-for="rol in user.roles">{{rol.name}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
<!--                        <ul class="d-custom-flex list-unstyled footer-content text-center w-100 border-top-1">-->
<!--                            <li>-->
<!--                                <h5 class="mb-0">70</h5>-->
<!--                                <span class="fs-12 grey&#45;&#45;text fw-normal">Prescripciones</span>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <h5 class="mb-0">20</h5>-->
<!--                                <span class="fs-12 grey&#45;&#45;text fw-normal">Quejas</span>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <h5 class="mb-0">62</h5>-->
<!--                                <span class="fs-12 grey&#45;&#45;text fw-normal">Likes</span>-->
<!--                            </li>-->
<!--                        </ul>-->
                    </div>
                </app-card>
			</v-layout>
		</v-container>
        <app-section-loader :status="loader"></app-section-loader>
        <register-user-dialog v-if="permisos.edit || permisos.add" ref="dialogRegisterUsuario" @onSuccess="getData"></register-user-dialog>
	</div>
</template>

<script>
export default {
    components: {
        MobileSearchForm: () => import('@/components/Header/MobileSearchForm'),
        RegisterUserDialog: () => import('@/components/Usuarios/RegisterUserDialog')
    },
    data: () => ({
        searchUsuario: null,
        loader: true,
        users: null
    }),
    computed: {
        permisos () {
            return this.$store.getters.getPermissionModule('user')
        }
    },
    watch: {
      'searchUsuario' () {
          this.getData()
      }
    },
	created () {
      this.getData()
	},
  methods: {
        registerUser (id) {
          this.$refs.dialogRegisterUsuario.open(id)
        },
        getData: window.lodash.debounce(function () {
            this.loader = true
            let url = this.searchUsuario ? `users?filter[search]=${this.searchUsuario}` : `users`
            this.axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        this.users = response.data
                        this.loader = false
                    }
                }).catch(e => {
                this.loader = false
                this.$store.commit('snackbar', {color: 'error', message: `al recuperar el listado de usuarios`, error: e})
            })
        }, 500),
      toggleSearchForm() {
          this.$store.dispatch('toggleSearchForm')
      }
  }
}
</script>
